// src/config/brandingMap.ts

export interface BrandingInfo {
    appName: string;
    logoUrl: string;
    faviconUrl: string;
  }
  
  export const brandingMap: Record<string, BrandingInfo> = {
    'matchmaker.ypog.law': {
      appName: 'MatchMaker',
      logoUrl: '/branding/matchmaker/logo.png',
      faviconUrl: '/branding/matchmaker/favicon.ico',

    },
    'dev.matchmaker.ypog.law': {
      appName: 'MatchMaker Dev',
      logoUrl: '/branding/matchmaker/logo.png',
      faviconUrl: '/branding/matchmaker/favicon.ico',

    },
    'partners.forum': {
      appName:  "Managing Partners' Speed Dating",
      logoUrl: '/branding/forum/logo.png',
      faviconUrl: '/branding/forum/favicon.ico',

    },
    'dev.partners.forum': {
      appName: "Managing Partners' Speed Dating Dev",
      logoUrl: '/branding/forum/logo.png',
      faviconUrl: '/branding/forum/favicon.ico',

    },
    'localhost': {
      appName: "Managing Partners' Speed Dating Dev",
      logoUrl: '/branding/forum/logo.png',
      faviconUrl: '/branding/forum/favicon.ico',

    },
    '127.0.0.1': {
      appName: "Managing Partners' Speed Dating Dev",
      logoUrl: '/branding/forum/logo.png',
      faviconUrl: '/branding/forum/favicon.ico',

    },
  };
  